module.exports = __webpack_public_path__ + "static/media/index_01.e0baaf9f.png";